import { Link } from "react-router-dom";
import { ArrowRight, Coins, Sparkles, Trophy, ShieldCheck } from "lucide-react";

export default function Landing() {
  return (
    <div className="vexis-ambient min-h-screen">
      <header className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="chip-icon text-[24px]" />
          <span className="font-display text-xl tracking-tight">VEXIS</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/auth?mode=login" className="btn-ghost text-sm" data-testid="nav-signin">Sign in</Link>
          <Link to="/auth?mode=register" className="btn-gold text-sm" data-testid="nav-signup">Create account</Link>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-4 pt-8 sm:pt-16 pb-16 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 enter">
          <div className="pill pill-gold mb-5" data-testid="hero-pill">
            <span>Real Stakes · Real Skill</span>
          </div>
          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-slate-100">
            The house has <em className="not-italic text-[color:var(--gold)]">no edge</em> when skill decides.
          </h1>
          <p className="mt-6 text-base sm:text-lg text-slate-400 max-w-xl">
            VEXIS is an elegant skill casino built around three quiet obsessions —
            <span className="text-slate-200"> Memory Matrix</span>,
            <span className="text-slate-200"> 2048 Vault</span>, and
            <span className="text-slate-200"> Minesweeper Tactical</span>. Wager chips,
            play with precision, cash out on your terms.
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-8">
            <Link to="/auth?mode=register" className="btn-gold inline-flex items-center gap-2" data-testid="cta-primary">
              Start with 500 free chips <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/auth?mode=login" className="btn-ghost text-sm" data-testid="cta-secondary">I already have an account</Link>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-3 text-sm">
            {[
              { icon: Coins, label: "Buy chips via Stripe" },
              { icon: Sparkles, label: "AI daily challenges" },
              { icon: Trophy, label: "Global leaderboard" },
            ].map((f) => (
              <div key={f.label} className="vexis-card p-4 flex items-center gap-3">
                <f.icon className="w-4 h-4 text-[color:var(--gold)]" />
                <span className="text-slate-300">{f.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 enter">
          <div className="relative vexis-card p-6 sm:p-8 overflow-hidden">
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full" style={{background: "radial-gradient(closest-side, rgba(226,185,106,0.25), transparent)"}} />
            <div className="pill mb-4">Live Table</div>
            <div className="grid grid-cols-4 gap-2">
              {[2,4,8,16,32,64,128,256,512,1024,64,2048,32,4,8,2].map((n,i) => (
                <div key={i} className={`tile aspect-square text-sm sm:text-base t-${n}`} data-testid={`hero-tile-${i}`}>{n}</div>
              ))}
            </div>
            <div className="mt-6 flex items-center justify-between">
              <div className="font-mono text-xs uppercase tracking-widest text-slate-500">Best tile</div>
              <div className="font-display text-2xl text-[color:var(--gold)]">2048</div>
            </div>
            <div className="mt-4 gold-hairline" />
            <div className="mt-4 flex items-center gap-2 text-xs text-slate-400">
              <ShieldCheck className="w-4 h-4 text-emerald-400" /> Provably skill-based · House edge 3%
            </div>
          </div>
        </div>
      </section>

      <footer className="max-w-6xl mx-auto px-4 py-10 text-xs text-slate-500 flex justify-between">
        <div>© {new Date().getFullYear()} VEXIS — Play responsibly.</div>
        <div className="font-mono">v1.0 · preview</div>
      </footer>
    </div>
  );
}
